import PropTypes from 'prop-types';
import React, { memo, useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { convertEpochToDate } from '../../utilities/helpers.js';
import CustomModal from '../CustomModal.jsx';
import Spinners from '../Spinner.jsx';
import { PaginationInfo } from '../Table/Helpers.jsx';
import styles from "./gray-box.module.scss";


const CustomGrayBox = ({
    AccordionBgClass = '',
    PageTitle = '',
    data = [],
    headings = [],
    initialData = {},
    loading = false,
    onPageChange = () => { },
    onPageLimitChange = () => { },
    onSearch = () => { },
    page = 0,
    pageLimit = 10,
    pageLink = '',
    searchAndRow = true,
    searchKey,
    totalItems = 0,
    withColumn = null, }) => {

    const [pageInput, setPageInput] = useState(page + 1);
    const totalPageCount = totalItems
        ? Math.ceil(totalItems / pageLimit)
        : 0;
    const isLastPage = page === totalPageCount - 1;
    const [pageSizeInput, setPageSizeInput] = useState(pageLimit);
    const [filteredItems, setFilteredItems] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [popUpContent, setPopupContent] = useState("");
    const [searchInputValue, setSearchInputValue] = useState(searchKey ? searchKey : '');
    const navigate = useNavigate();

    useEffect(() => {
        setFilteredItems(data);
    }, [data], [filteredItems]);

    useEffect(() => {
        setSearchInputValue(searchKey);
    }, [searchKey]);

    const handleShowPopup = (desc, num) => {
        setShowPopup(true);
        setPopupContent({
            num: num,
            desc: desc
        });
    };

    const closePopup = () => {
        setShowPopup(false);
    };


    const handleNavigation = (item, heading) => {
        //checkB and item?.assessmentQuestionId ensures that are from questions page
        if (heading.checkB === true && item?.assessmentQuestionId) {
            const currentState = JSON.parse(localStorage.getItem('raNavState')) || {};

            // Merge the current state with new values
            const updatedState = {
                ...currentState,
                Id: item?.assessmentQuestionId, ...initialData
            };

            // Save the updated state back to localStorage
            localStorage.setItem('raNavState', JSON.stringify(updatedState));
            navigate("/RiskAssessment/RiskAssessment/Topics/SubTopics/Clause/Questions/Assessment");
        }
        if (heading.checkB === true && heading.percentage) {
            updateRiskAssessmentStateInLocalStorage(item);
            navigate(pageLink);
        }
    };

    const updateRiskAssessmentStateInLocalStorage = (item) => {
        // Get the current state from localStorage
        const currentState = JSON.parse(localStorage.getItem('raNavState')) || {};

        // Merge the current state with new values
        const updatedState = {
            ...currentState,
            ...(item?.topicName && { topicName: item.topicName }),
            ...(item?.subTopicName && { subTopicName: item.subTopicName }),
            ...(item?.clauseNo && { clauseNo: item.clauseNo }),
            ...(item?.clauseName && { clauseName: item.clauseName }),
        };

        // Save the updated state back to localStorage
        localStorage.setItem('raNavState', JSON.stringify(updatedState));
    };


    function showPage() {
        return filteredItems?.map((item, index) => {
            if (withColumn) {
                const columnClass = `col-sm-${Math.floor(12 / withColumn)}`;
                return (
                    <div key={index} className={`item ${PageTitle === "Clause" || PageTitle === "Questions" ? "col-sm-2" : "col-sm-4"} mt-3`}>
                        <Card className={`p-3 border-0 ${AccordionBgClass}`} >
                            {headings.map((heading, headingIndex) => (
                                <React.Fragment key={headingIndex} >
                                    {heading.checkB ? (
                                        <a onClick={() => handleNavigation(item, heading)}
                                            data-testid={`card-item-link-${index}-${headingIndex}`}>
                                            <div className={heading.sideDiv ? `float-end ${styles.greyBoxCustomAlignment} d-flex justify-content-between` : " d-flex justify-content-between"}>
                                                <div id="PluginClick">{`${heading.showLabel ? item[heading.label] : item[heading.value]}`} </div>
                                                <div className="d-flex">
                                                    {heading.percentage ? `${item[heading.percentage]}%` : ""}
                                                    {(item[heading.isCompleted] === true || item[heading.isCompleted] === "true" || item[heading.isCompleted] === "Yes" || item[heading.isCompleted?.split("&&")[0]] === "Yes" || item[heading.isCompleted?.split("&&")[1]] === true) && <IoIosCheckmarkCircle color="#a5cd39" size={20} style={{ marginLeft: "5px" }} />}
                                                </div>
                                            </div>
                                        </a>
                                    ) : (

                                        <a
                                            onClick={() => {
                                                updateRiskAssessmentStateInLocalStorage(item);
                                                navigate(pageLink);
                                            }}
                                            data-testid={`card-item-link-${index}-${headingIndex}`}
                                        >
                                            <div>
                                                <div className={heading.sideDiv ? `float-end ${styles.greyBoxCustomAlignment} d-flex justify-content-between` : " d-flex justify-content-between"}>

                                                    <div id="PluginClick" className="text-truncate greyBoxContent" >{heading.showLabel ? heading.label : item[heading.value]}</div>
                                                    <div className="d-flex">
                                                        {heading.percentage ? `${item[heading.percentage]}%` : ""}
                                                        {(item[heading.percentage] === 100) && <IoIosCheckmarkCircle color="#a5cd39" size={20} style={{ marginLeft: "5px" }} />}
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    )}
                                </React.Fragment>
                            ))}
                        </Card>
                    </div>
                );
            } else {
                return (
                    <div key={index} className="item col-sm-12 mt-3 px-0">
                        <Card className={`p-3 border-0 ${AccordionBgClass}`}>
                            <Row>
                                {headings.map((heading, index) => (
                                    <React.Fragment key={index}>
                                        <Col md={6}>
                                            <div className="d-flex my-1">
                                                <div ><strong>{heading.label} :</strong></div>
                                                <div id={heading.link && "PluginClick"} onClick={() => {
                                                    if (heading.label === "Clause No") {
                                                        handleShowPopup(item[heading.description], item[heading.value]);
                                                    }
                                                }} className="mx-2" data-testid={`clause-detail-link-${index}-${heading.label}`}>{heading.epoc ? item[heading.value] == 0 ? " - " : convertEpochToDate(item[heading?.value]) : item[heading?.value] == null ? "-" : item[heading?.value]}{heading.isPercentage ? "%" : ""}</div>
                                            </div>
                                        </Col>
                                    </React.Fragment>
                                ))}
                            </Row>
                        </Card>
                    </div>
                );
            }
        });
    }

    const handleKeyDown = (event) => {
        if (event.key === ' ' && searchInputValue?.length === 0) {
            event.preventDefault();
        }
        if (event.key === 'Enter') {
            onSearch(event.target.value);
        }
    };

    const handleInputChangePageSize = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value) && Number(value) <= 100) {
            setPageSizeInput(value);
        }
    };


    const handleKeyPressPagesize = (e) => {
        if (e.key === 'Enter') {
            const newSize = Number(pageSizeInput);
            if (newSize >= 1 && newSize <= 100) {
                onPageLimitChange(newSize);
                handlePageSizeChange(newSize);
            }
        }
    };


    const handleInputChange = (e) => {
        const newValue = e.target.value.trimStart();

        setSearchInputValue(newValue);

        // Trigger search when input is cleared
        if (e.target.value === '') {
            if (newValue !== searchKey) {
                onSearch(newValue);
            }
        }
    };
    const handleSearchClick = () => {
        onSearch(searchInputValue);
    };

    const popUpModalBody = () => {
        return (
            <>
                <div>
                    <h4 className="modal-body2 ">
                        <table>
                            <tr className="d-flex">
                                <th className={styles.tablecontrolid2}>Clause No :</th>
                                <td>{popUpContent?.num}</td>
                            </tr>
                        </table>
                    </h4>
                </div>
                <div >
                    <table>
                        <tr className="d-flex">
                            <h6 className="mt-1">Clause Details :</h6>
                            <td className="text-start ms-1">{popUpContent?.desc}</td>
                        </tr>
                    </table>
                </div>
            </>
        );
    };

    const handleBlurPageSize = () => {
        const newSize = Number(pageSizeInput);
        if (!newSize || newSize < 1 || newSize > 100) {
            setPageSizeInput(sizeOfPage);
        } else {
            onPageLimitChange(newSize);
            handlePageSizeChange(newSize);
        }
    };
    const handleFirstPageClick = () => {
        setPageInput(1);
        onPageChange(0);
    };
    const handleLastPageClick = () => {
        setPageInput(totalPageCount);
        onPageChange(totalPageCount - 1);
    };

    const handlePreviousClick = () => {
        if (page > 0) {
            const newPageNumber = page - 1;
            onPageChange(newPageNumber);
            setPageInput(pageInput);
        }
    };

    const handleNextClick = () => {
        const newPageNumber = page + 1;
        onPageChange(newPageNumber);
        setPageInput(pageInput);
    };

    const handlePageSizeChange = (newPageSize) => {
        onPageLimitChange(newPageSize);
        onPageChange(0);
    };

    const handleInputChangePage = (e) => {
        if (e.target.value <= totalPageCount) { setPageInput(e.target.value); }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            const newPage = parseInt(e.target.value, 10);
            if (!isNaN(newPage) && newPage > 0 && newPage <= totalPageCount) {
                onPageChange(newPage - 1);
            } else {
                setPageInput(page + 1);
            }
        }
    };

    const handleBlurPageInput = () => {
        if (pageInput < page + 1) {
            setPageInput(page + 1);
        }
    };

    useEffect(() => {
        setPageInput(page + 1);
    }, [page]);


    return (
        <div className={withColumn ? "container-fluid px-0" : "container-fluid"}>
            {searchAndRow ? (
                <div className="d-flex justify-content-end">
                    <div>
                        <li className="input-group serverInput searchStyle manageVulStyle">
                            <input
                                id="searchInput"
                                type="text"
                                className={`form-control ${styles.CustomSearchStyle}`}
                                placeholder="Search"
                                value={searchInputValue}
                                onChange={handleInputChange}
                                onKeyDown={handleKeyDown}
                                data-testid="search-input-field"
                            />
                            <button
                                className={`btn btn-light rounded-end ${styles.CustomSearchButton}`}
                                onClick={handleSearchClick}
                                data-testid="search-button"
                            >
                                <FaSearch />
                            </button>
                        </li>
                    </div>
                </div>
            ) : null}

            <div className="row" id="myList">
                {loading === true ? <Spinners /> : filteredItems?.length === 0 && withColumn ? <div className="projectemty text-center">
                    No Data Available
                </div> : showPage(page)}
            </div>

            {searchAndRow && totalItems > 1 ? (
                <div className="d-flex justify-content-between  mt-3  mb-0" style={{ alignItems: 'center' }}>
                    <div>
                        <PaginationInfo
                            currentPage={page}
                            pageSize={pageSizeInput}
                            listCount={totalItems}
                        />
                    </div>
                    <div className="d-flex justify-content-center">
                        <div className="d-flex align-items-center">
                            <div className="pe-3">
                                <button
                                    onClick={handleFirstPageClick}
                                    className={`far-back-icon ${pageInput === 1 ? 'disabled-icon' : ''}`}
                                    disabled={page === 0}
                                    style={{ cursor: pageInput === totalPageCount ? 'default' : 'pointer' }}
                                    data-testid="pagination-first-page"
                                >
                                    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0.400819 0.00162569H2.44586C2.55434 0.00162569 2.65837 0.0447184 2.73507 0.121424C2.81178 0.19813 2.85487 0.302165 2.85487 0.410643V3.73595L8.35603 0.0547979C8.4182 0.0188992 8.48874 0 8.56053 0C8.63233 0 8.70286 0.0188992 8.76504 0.0547979C8.83127 0.0881475 8.88718 0.138876 8.92681 0.201555C8.96643 0.264235 8.98827 0.336508 8.98999 0.410643V8.59098C8.98979 8.66498 8.96953 8.73753 8.93135 8.80091C8.89318 8.8643 8.83853 8.91614 8.77322 8.95092C8.70926 8.98376 8.63777 8.99916 8.56597 8.99557C8.49416 8.99198 8.42457 8.96952 8.36421 8.93047L2.86305 5.24931V8.59098C2.86305 8.69946 2.81996 8.8035 2.74325 8.8802C2.66655 8.95691 2.56252 9 2.45404 9H0.408998C0.300523 9 0.19649 8.95691 0.119786 8.8802C0.0430822 8.8035 -9.53674e-06 8.69946 -9.53674e-06 8.59098V0.410643C-3.05176e-05 0.303567 0.0419369 0.200753 0.11688 0.124278C0.191824 0.0478035 0.293767 0.00376719 0.400819 0.00162569Z" fill="#939393" />
                                    </svg>
                                </button>
                            </div>

                            <div className="pe-3">
                                <button
                                    className={`far-back-icon ${pageInput === 1 ? 'disabled-icon' : ''}`}
                                    onClick={handlePreviousClick}
                                    disabled={page === 0}
                                    style={{ cursor: pageInput === totalPageCount ? 'default' : 'pointer' }}
                                    data-testid="pagination-previous-page"
                                >
                                    <svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0.28873 3.68394L6.1982 0.0838961C6.28792 0.0298853 6.39012 0.000947745 6.49442 2.28866e-05C6.59872 -0.000901972 6.70141 0.0262187 6.79204 0.0786304C6.88268 0.131042 6.95803 0.206877 7.01046 0.298431C7.06289 0.389986 7.09051 0.493998 7.09053 0.599902V3.13793L12.1077 0.0838961C12.1974 0.0298853 12.2996 0.000947745 12.4039 2.28866e-05C12.5082 -0.000901972 12.6109 0.0262187 12.7015 0.0786304C12.7921 0.131042 12.8675 0.206877 12.9199 0.298431C12.9724 0.389986 13 0.493998 13 0.599902V8.39999C13.0002 8.51017 12.9706 8.61828 12.9143 8.71248C12.858 8.80667 12.7772 8.88331 12.6809 8.93399C12.5968 8.97775 12.5036 9.00038 12.4091 9C12.2886 8.99971 12.171 8.96202 12.0722 8.89199L7.09053 5.35195V8.39999C7.09075 8.51017 7.0611 8.61828 7.00481 8.71248C6.94852 8.80667 6.86777 8.88331 6.77142 8.93399C6.68731 8.97775 6.59409 9.00038 6.49958 9C6.37908 8.99971 6.26155 8.96202 6.16274 8.89199L0.253273 4.69195C0.172163 4.63461 0.106513 4.55753 0.0623312 4.46776C0.0181503 4.378 -0.00315189 4.27841 0.000375748 4.17813C0.00390339 4.07784 0.0321474 3.98006 0.0825233 3.89372C0.132899 3.80739 0.203797 3.73526 0.28873 3.68394Z" fill="#939393" />
                                    </svg>
                                </button>
                            </div>

                            <div className="page">Page</div>

                            <div className={styles.rectangle}>
                                <input
                                    className={styles.rectangle}
                                    type="number"
                                    value={pageInput}
                                    min={1}  // Ensure the minimum value is 1
                                    max={totalPageCount}
                                    onChange={handleInputChangePage}
                                    onKeyPress={handleKeyPress}
                                    onBlur={handleBlurPageInput}
                                    data-testid="pagination-page-input"
                                />
                            </div>

                            <div className="of-1">of {totalPageCount}</div>

                            <div className="ps-3">
                                <button
                                    className={`far-back-icon ${pageInput === totalPageCount ? 'disabled-icon' : ''}`}
                                    onClick={handleNextClick}
                                    disabled={isLastPage}
                                    style={{ cursor: pageInput === totalPageCount ? 'default' : 'pointer' }}
                                    data-testid="pagination-next-page"
                                >
                                    <svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.7113 3.68394L6.8018 0.0838961C6.71208 0.0298853 6.60988 0.000947745 6.50558 2.28866e-05C6.40128 -0.000901972 6.29859 0.0262187 6.20796 0.0786304C6.11732 0.131042 6.04197 0.206877 5.98954 0.298431C5.93711 0.389986 5.90949 0.493998 5.90947 0.599902V3.13793L0.892331 0.0838961C0.802611 0.0298853 0.70041 0.000947745 0.596109 2.28866e-05C0.491808 -0.000901972 0.389125 0.0262187 0.298489 0.0786304C0.207854 0.131042 0.132496 0.206877 0.08007 0.298431C0.0276445 0.389986 1.94686e-05 0.493998 1.27873e-06 0.599902V8.39999C-0.000224428 8.51017 0.0294334 8.61828 0.085723 8.71248C0.142013 8.80667 0.22276 8.88331 0.319113 8.93399C0.403223 8.97775 0.496442 9.00038 0.590948 9C0.711447 8.99971 0.828979 8.96202 0.927788 8.89199L5.90947 5.35195V8.39999C5.90925 8.51017 5.9389 8.61828 5.99519 8.71248C6.05148 8.80667 6.13223 8.88331 6.22858 8.93399C6.31269 8.97775 6.40591 9.00038 6.50042 9C6.62092 8.99971 6.73845 8.96202 6.83726 8.89199L12.7467 4.69195C12.8278 4.63461 12.8935 4.55753 12.9377 4.46776C12.9818 4.378 13.0032 4.27841 12.9996 4.17813C12.9961 4.07784 12.9679 3.98006 12.9175 3.89372C12.8671 3.80739 12.7962 3.73526 12.7113 3.68394Z" fill="#939393" />
                                    </svg>
                                </button>
                            </div>

                            <div className="ps-3">
                                <button
                                    onClick={handleLastPageClick}
                                    className={`far-back-icon ${pageInput === totalPageCount ? 'disabled-icon' : ''}`}
                                    disabled={isLastPage}
                                    style={{ cursor: pageInput === totalPageCount ? 'default' : 'pointer' }}
                                    data-testid="pagination-last-page"
                                >
                                    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.58917 0.00162569H6.54413C6.43566 0.00162569 6.33162 0.0447184 6.25492 0.121424C6.17821 0.19813 6.13512 0.302165 6.13512 0.410643V3.73595L0.633963 0.0547979C0.571786 0.0188992 0.501254 0 0.429459 0C0.357663 0 0.287132 0.0188992 0.224954 0.0547979C0.158724 0.0881475 0.102805 0.138876 0.063181 0.201555C0.0235568 0.264235 0.00171766 0.336508 0 0.410643V8.59098C0.000197432 8.66498 0.0204627 8.73753 0.0586369 8.80091C0.0968111 8.8643 0.151464 8.91614 0.216774 8.95092C0.280732 8.98376 0.352216 8.99916 0.424022 8.99557C0.495828 8.99198 0.56542 8.96952 0.625782 8.93047L6.12694 5.24931V8.59098C6.12694 8.69946 6.17003 8.8035 6.24674 8.8802C6.32344 8.95691 6.42747 9 6.53595 9H8.58099C8.68947 9 8.7935 8.95691 8.8702 8.8802C8.94691 8.8035 8.99 8.69946 8.99 8.59098V0.410643C8.99002 0.303567 8.94805 0.200753 8.87311 0.124278C8.79817 0.0478035 8.69622 0.00376719 8.58917 0.00162569Z" fill="#939393" />
                                    </svg>
                                </button>
                            </div>

                        </div>
                    </div>
                    <div className=''>
                        <ul className='checkStyle mt-1'>
                            <li className='rowsPerPage'>
                                <label className="page mt-2" htmlFor="page-size-select" style={{ whiteSpace: 'pre-wrap' }}>
                                    Rows per page   </label>
                                <div className="form-group" style={{ display: 'inline-block', marginRight: '10px' }}>
                                    <input
                                        className={styles["rectangle-Rows"]}
                                        type="number"
                                        value={pageSizeInput}
                                        min="1"
                                        max="100"
                                        onChange={handleInputChangePageSize}
                                        onKeyPress={handleKeyPressPagesize}
                                        onBlur={handleBlurPageSize}
                                        style={{ width: '60px', height: '38px' }}
                                        data-testid="pagination-rows-per-page"
                                    />
                                </div>

                            </li>
                        </ul>
                    </div>
                </div>
            ) : null}
            <CustomModal modalBody={popUpModalBody} modalOpen={showPopup} modalHide={closePopup} closeBtn={true} closeBtnFuc={closePopup} />
        </div>
    );
};

export default memo(CustomGrayBox);

CustomGrayBox.propTypes = {
    AccordionBgClass: PropTypes.string,
    PageTitle: PropTypes.string,
    data: PropTypes.array,
    headings: PropTypes.arrayOf(PropTypes.object),
    initialData: PropTypes.object,
    loading: PropTypes.bool,
    onPageChange: PropTypes.func,
    onPageLimitChange: PropTypes.func,
    onSearch: PropTypes.func,
    page: PropTypes.number,
    pageLimit: PropTypes.number,
    pageLink: PropTypes.string,
    searchAndRow: PropTypes.bool,
    searchKey: PropTypes.string,
    totalItems: PropTypes.number,
    withColumn: PropTypes.number,
};



